import { makeStyles } from "@fluentui/react-components";

export const useMenuStyles = makeStyles({
  portal: {
    zIndex: 99999,
  },
});
